import { eCancellationRequestStatus } from './eCancellationRequestStatus';
import { eUserType } from './eUserType';

export interface IOrderCancellationRequestResponse {
  id: string;
  created_at: string;
  updated_at: string;
  status: eCancellationRequestStatus;
  cancellation_reason?: string;
  requester_user_type: eUserType;
  requester_user_id: string;
  resolver_user_id?: string;
  resolver_user_type?: eUserType;
  resolver_reason?: string;
}

export interface IOrderCancellationRequestData {
  id: string;
  createdAt: string;
  updatedAt: string;
  status: eCancellationRequestStatus;
  cancellationReason?: string;
  requesterUserType: eUserType;
  requesterUserId: string;
  resolverUserType?: eUserType;
  resolverUserId?: string;
  resolverReason?: string;
}

export const convertFromCancellationStatusResponseToCancellationStatusData = (
  data: IOrderCancellationRequestResponse
): IOrderCancellationRequestData => ({
  id: data.id,
  createdAt: data.created_at,
  updatedAt: data.updated_at,
  status: data.status,
  cancellationReason: data.cancellation_reason,
  requesterUserType: data.requester_user_type,
  requesterUserId: data.requester_user_id,
  resolverUserType: data.resolver_user_type,
  resolverUserId: data.resolver_user_id,
  resolverReason: data.resolver_reason,
});
